/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GlobalResponsesToCommentsRatioQueryVariables = Types.Exact<{
  isUserAllowedToReadComments: Types.Scalars['Boolean'];
  surveyContentType: Types.SurveyContentType;
}>;


export type GlobalResponsesToCommentsRatioQuery = { commentsStatistics: { responsesToCommentsRatio: number } };


export const GlobalResponsesToCommentsRatioDocument = gql`
    query GlobalResponsesToCommentsRatio($isUserAllowedToReadComments: Boolean!, $surveyContentType: SurveyContentType!) {
  commentsStatistics: getStatisticsGlobal(surveyContentType: $surveyContentType) @include(if: $isUserAllowedToReadComments) {
    responsesToCommentsRatio: percentage_treated_recipient_comment
  }
}
    `;

/**
 * __useGlobalResponsesToCommentsRatioQuery__
 *
 * To run a query within a React component, call `useGlobalResponsesToCommentsRatioQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalResponsesToCommentsRatioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalResponsesToCommentsRatioQuery({
 *   variables: {
 *      isUserAllowedToReadComments: // value for 'isUserAllowedToReadComments'
 *      surveyContentType: // value for 'surveyContentType'
 *   },
 * });
 */
export function useGlobalResponsesToCommentsRatioQuery(baseOptions: Apollo.QueryHookOptions<GlobalResponsesToCommentsRatioQuery, GlobalResponsesToCommentsRatioQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalResponsesToCommentsRatioQuery, GlobalResponsesToCommentsRatioQueryVariables>(GlobalResponsesToCommentsRatioDocument, options);
      }
export function useGlobalResponsesToCommentsRatioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalResponsesToCommentsRatioQuery, GlobalResponsesToCommentsRatioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalResponsesToCommentsRatioQuery, GlobalResponsesToCommentsRatioQueryVariables>(GlobalResponsesToCommentsRatioDocument, options);
        }
export type GlobalResponsesToCommentsRatioQueryHookResult = ReturnType<typeof useGlobalResponsesToCommentsRatioQuery>;
export type GlobalResponsesToCommentsRatioLazyQueryHookResult = ReturnType<typeof useGlobalResponsesToCommentsRatioLazyQuery>;
export type GlobalResponsesToCommentsRatioQueryResult = Apollo.QueryResult<GlobalResponsesToCommentsRatioQuery, GlobalResponsesToCommentsRatioQueryVariables>;